import { FlowsGroup, FlowsGroupNoWaste } from 'hooks/data/datasets/V4/flows/types';
import { groupToTooltipLabel, groupToTooltipTitle } from 'pages/Flows/FlowsView/utils/constants';

import { getExchangeSection } from './exchangesUtils';

export const exchangeGroupToFlowsGroup = (group: string): FlowsGroup => {
  switch (group) {
    case 'From technosphere':
      return 'valuable';
    case 'Reference product':
      return 'reference flow';
    case 'Waste to treatment':
      return 'waste';
    case 'By-product (Allocatable)':
    case 'By-product (Recyclable)':
    case 'By-product (Waste)':
      return 'by-product';
    case 'From environment':
      return 'resource';
    case 'To environment':
      return 'emission';
    default:
      return 'valuable';
  }
};

const WASTE_TOOLTIP_BODY: Record<'input' | 'output', string> = {
  input:
    'This flow represents waste materials received by the process from other systems for treatment, recycling, reuse or disposal.',
  output: 'This flow represents a waste material generated by the process that requires disposal, treatment, or management.',
};

// Overrides V4's by-product label, which still holds placeholder copy; delete once V4's copy is fixed.
const BY_PRODUCT_TOOLTIP_BODY =
  "This flow represents a secondary output produced by the process alongside its reference product. By-products are goods or services that carry a share of the process's environmental burden.";

export const getExchangeTooltip = (group: string): { title: string; body: string } => {
  const flowsGroup = exchangeGroupToFlowsGroup(group);

  return { title: groupToTooltipTitle[flowsGroup], body: tooltipBody(group, flowsGroup) };
};

const tooltipBody = (group: string, flowsGroup: FlowsGroup): string => {
  if (flowsGroup === 'waste') return WASTE_TOOLTIP_BODY[getExchangeSection(group)];
  if (flowsGroup === 'by-product') return BY_PRODUCT_TOOLTIP_BODY;

  return groupToTooltipLabel[flowsGroup as FlowsGroupNoWaste];
};
